import { createRoot } from 'react-dom/client';

import Index from './components/homepage';

export default () => {
  const root = createRoot(document.getElementById('reactRoot'));
  root.render(<Index />);
};
